import axios from 'axios';

const instance = axios.create({
    baseURL : 'http://14.139.244.168/api'
    //baseURL : 'http://localhost:5002/api'
});

export default instance;